<template>
  <b-container fluid>
    <b-row
      class="justify-content-between"
      cols="auto"
      md="auto"
      lg="auto"
    >
      <b-col>
        <b-input-group style="margin-bottom: 10px">
          <b-input-group-append>
            <div class="o-search">
              <i class="fa fa-search" />
            </div>
          </b-input-group-append>
          <b-form-input
            v-model="filter"
            placeholder="SEARCH"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              <i class="fa fa-times" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-table
          id="tenants"
          primary-key="id"
          head-variant="light"
          fixed
          small
          responsive
          :busy="isLoading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="tenants"
          :fields="fields"
          :per-page="selectedPageSize"
          :total-rows="rows"
          :current-page="currentPage"
          :filter="filter"
          style="background-color: transparent"
          @filtered="onFiltered"
        >
          <div
            slot="table-busy"
            class="text-center my-2"
          >
            <b-spinner class="align-middle" />
            <span class="o-strong">&nbsp;Loading&hellip;</span>
          </div>
          <!-- Custom Columns -->
          <template
            slot="enabled"
            slot-scope="row"
          >
            <div v-if="row.item.enabled === true">
              <i
                v-b-tooltip.hover.left
                class="fa fa-circle o-enabled"
                title="Enabled"
              />
            </div>
            <div v-else>
              <i
                v-b-tooltip.hover.left
                class="fa fa-circle o-disabled"
                title="Disabled"
              />
            </div>
          </template>
          <template
            slot="manage"
            slot-scope="row"
          >
            <b-button
              v-b-tooltip.hover.left
              variant="link"
              class="px-0 py-1"
              title="Manage Clients"
              @click="loadClients(row.item)"
            >
              <i class="fa fa-sitemap" />
            </b-button>
          </template>
          <template
            slot="edit"
            slot-scope="row"
          >
            <b-button
              v-b-tooltip.hover.left
              variant="link"
              class="px-0 py-1"
              title="Edit Tenant"
              @click="editTenant(row.item)"
            >
              <i class="fa fa-pencil" />
            </b-button>
          </template>
          <template
            slot="delete"
            slot-scope="row"
          >
            <b-button
              v-b-tooltip.hover.left
              variant="link"
              class="px-0 py-1"
              title="Delete Tenant"
              @click="deleteTenant(row.item)"
            >
              <i class="fa fa-trash" />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-show="isLoading === false">
      <b-col
        cols="auto"
        class="pr-2"
      >
        <b-pagination
          v-model="currentPage"
          size="sm"
          :total-rows="rows"
          :per-page="selectedPageSize"
          aria-controls="apiResources"
        />
      </b-col>
      <b-col
        cols="auto"
        class="mr-sm-auto mr-lg-0 o-page-count"
      >
        OF&nbsp;
        <span class="o-strong">{{ pageCount }}</span>
      </b-col>
      <b-col
        sm="12"
        lg="auto"
        class="o-page-size"
      >
        <b-form-group>
          <b-select
            id="pageSize"
            :value="selectedPageSize"
            class="ml-0 ml-lg-2"
            style="width: 65px"
            :options="options"
            size="sm"
            @input="updatePageSize"
          />
          <label
            class="mr-3"
            for="pageSize"
          >PER PAGE</label>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert
          v-model="showAlert"
          variant="danger"
          dismissible
        >
          {{ alertMessage }}
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "TenantList",
  components: {},
  data() {
    return {
      tenants: [],
      totalRows: -1,
      sortBy: "name",
      sortDesc: false,
      tenantName: "",
      filter: "",
      fields: [
        {
          key: "name",
          label: "Name",
          thClass: "text-truncate",
          tdClass: "text-truncate",
        },
        {
          key: "subdomain",
          label: "Subdomain",
          thClass: "text-truncate",
          tdClass: "text-truncate",
        },
        {
          key: "tenantId",
          label: "Tenant ID",
          thClass: "text-truncate",
          tdClass: "text-truncate",
        },
        { key: "enabled", label: "", thClass: "o-th", tdClass: "o-td-center" },
        { key: "manage", label: "", thClass: "o-th", tdClass: "o-td-center" },
        { key: "edit", label: "", thClass: "o-th", tdClass: "o-td-center" },
        { key: "delete", label: "", thClass: "o-th", tdClass: "o-td-center" },
      ],
      options: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 15, text: "15" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 50, text: "50" },
      ],
    };
  },
  created() {
    this.filter = this.$store.state.tenantFilter;
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
    ...mapGetters({
      isLoading: "isLoading",
      selectedPageSize: "tenantListPageSize",
    }),
    showAlert: {
      get() {
        return this.$store.getters.showAlert;
      },
      set(value) {
        this.$store.dispatch("showAlert", value);
      },
    },
    alertMessage: {
      get() {
        return this.$store.getters.alertMessage;
      },
      set(value) {
        this.$store.dispatch("alertMessage", value);
      },
    },
    currentPage: {
      get() {
        return this.$store.getters.tenantListCurrentPage;
      },
      set(value) {
        this.$store.dispatch("tenantListCurrentPage", value);
      },
    },
    rows() {
      return this.totalRows;
    },
    pageCount() {
      let totalPages = Math.floor(
        Number(this.rows) / Number(this.selectedPageSize)
      );
      if (Number(this.rows) % Number(this.selectedPageSize) != 0) totalPages++;
      return totalPages;
    },
    listFooter() {
      let recordFrom = (this.currentPage - 1) * this.selectedPageSize + 1;
      let recordTo = this.currentPage * this.selectedPageSize;
      recordTo = recordTo > this.rows ? this.rows : recordTo;
      return `Records: [${recordFrom} - ${recordTo}] of ${this.rows} Total`;
    },
  },
  mounted() {
    this.loadTenantList();
  },
  methods: {
    ...mapActions({
      updatePageSize: "tenantListPageSize",
    }),
    loadTenantList() {
      this.$axios
        .get("/api/tenants")
        .then((response) => {
          this.tenants = response.data;
          this.totalRows = this.tenants.length;
        })
        .catch((error) => {
          this.alertMessage = error;
        });
    },
    loadClients(item) {
      this.$router.push({ path: `tenants/${item.id}/clients` });
    },
    addTenant() {
      this.$router.push({ path: `tenants/new` });
    },
    editTenant(item) {
      this.$router.push({ path: `tenants/${item.id}/edit` });
    },
    deleteTenant(item) {
      this.dialogResult = "";
      let msg = `Continue to delete ${item.name}?`;
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: "Please Confirm",
          size: "lg",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.$axios
              .delete(`/api/tenants/${item.id}/delete`)
              .then(() => {
                this.tenants = this.tenants.filter((t) => t.id != item.id);
                this.totalRows = this.tenants.length;
              })
              .catch((error) => {
                this.alertMessage = error;
              });
          }
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows =
        this.filter === "" ? this.tenants.length : filteredItems.length;
      this.$store.commit('setTenantFilter', this.filter);
    },
  },
};
</script>
